import React from "react";
import { LeadsListView } from "../../../components/LeadsListView";
import { useAdminAuth } from "../../auth/AdminAuthContext";

export function ExhibitorLeadsPage() {
  const { user } = useAdminAuth();

  if (!user?.assignedEventId || !user?.assignedCompanyId) {
    return (
      <div className="p-6 text-gray-500 text-[14px]">
        Нет доступа к лидам. Войдите как экспонент.
      </div>
    );
  }

  return (
    <LeadsListView
      eventId={user.assignedEventId}
      companyId={user.assignedCompanyId}
      basePath="/exhibitor/leads"
      audience="admin"
      showBack={false}
      direction="inbound"
      title="Вас сканировали"
    />
  );
}
